import { defineComponent as w, resolveComponent as p, openBlock as t, createElementBlock as o, normalizeClass as a, createBlock as r, withCtx as s, createVNode as b, Fragment as l, createTextVNode as m, toDisplayString as u, createCommentVNode as i } from "vue";
import { V as k } from "../../../VImage-b57fd9d1.js";
import y from "../VLink/VLink.js";
import V from "../VSubtitle/VSubtitle.js";
import v from "../VText/VText.js";
import { S as C } from "../../../Spacing-695d3b19.js";
import { _ as S } from "../../../_plugin-vue_export-helper-dad06003.js";
import "../../../composables/useSpacingClass.js";
import "../../../utils/isExternalUrl.js";
import "../../../utils/tailwindUnitsConverter.js";
const h = w({
  name: "VImageCard",
  components: { VImage: k, VLink: y, VText: v, VSubtitle: V },
  emits: ["image-card:clicked"],
  props: {
    image: {
      type: String,
      required: !0
    },
    title: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    descriptionClampText: {
      type: Boolean,
      default: !1
    },
    target: {
      type: String,
      default: ""
    },
    border: {
      type: Boolean,
      default: !1
    },
    router: {
      type: Object,
      required: !0,
      default: void 0
    }
  },
  data() {
    return {
      Spacing: C
    };
  },
  computed: {
    borderRadius() {
      return this.$props.border ? "top-round" : "all-round";
    }
  }
});
function T(e, c, z, I, R, $) {
  const g = p("VImage"), d = p("VText"), n = p("VSubtitle"), f = p("VLink");
  return t(), o("div", {
    class: a(["tw-flex-shrink-0", {
      "hobi-image-card--border tw-box-border tw-border tw-border-solid tw-border-gray-300": e.border
    }])
  }, [
    e.target ? (t(), r(f, {
      key: 0,
      href: e.target,
      onClick: c[0] || (c[0] = (B) => e.$emit("image-card:clicked")),
      router: e.router
    }, {
      default: s(() => [
        b(g, {
          image: e.image,
          altText: e.title,
          "border-radius": e.borderRadius,
          aspectRatio: 1.4
        }, null, 8, ["image", "altText", "border-radius", "aspectRatio"]),
        e.description || e.title ? (t(), o("div", {
          key: 0,
          class: a(["tw-pt-4", { "tw-px-4 tw-pb-6": e.border }])
        }, [
          e.border ? (t(), o(l, { key: 0 }, [
            e.description ? (t(), r(d, {
              key: 0,
              size: "s",
              "bottom-spacing": e.Spacing.xs,
              class: a({
                "hobi-image-card__description--lineclamp tw-overflow-hidden tw-overflow-ellipsis tw-break-words": e.descriptionClampText
              })
            }, {
              default: s(() => [
                m(u(e.description), 1)
              ]),
              _: 1
            }, 8, ["bottom-spacing", "class"])) : i("", !0),
            e.title ? (t(), r(n, {
              key: 1,
              title: e.title,
              size: "xs"
            }, null, 8, ["title"])) : i("", !0)
          ], 64)) : (t(), o(l, { key: 1 }, [
            e.title ? (t(), r(n, {
              key: 0,
              title: e.title,
              size: "s"
            }, null, 8, ["title"])) : i("", !0),
            e.description ? (t(), r(d, {
              key: 1,
              size: "xs",
              "top-spacing": e.Spacing.s,
              class: a({
                "hobi-image-card__description--lineclamp tw-overflow-hidden tw-overflow-ellipsis tw-break-words": e.descriptionClampText
              })
            }, {
              default: s(() => [
                m(u(e.description), 1)
              ]),
              _: 1
            }, 8, ["top-spacing", "class"])) : i("", !0)
          ], 64))
        ], 2)) : i("", !0)
      ]),
      _: 1
    }, 8, ["href", "router"])) : (t(), o(l, { key: 1 }, [
      b(g, {
        image: e.image,
        altText: e.title,
        "border-radius": e.borderRadius,
        aspectRatio: 1.4
      }, null, 8, ["image", "altText", "border-radius", "aspectRatio"]),
      e.description || e.title ? (t(), o("div", {
        key: 0,
        class: a(["tw-pt-4", { "tw-px-4 tw-pb-6": e.border }])
      }, [
        e.border ? (t(), o(l, { key: 0 }, [
          e.description ? (t(), r(d, {
            key: 0,
            size: "s",
            "bottom-spacing": e.Spacing.xs,
            class: a({
              "hobi-image-card__description--lineclamp tw-overflow-hidden tw-overflow-ellipsis tw-break-words": e.descriptionClampText
            })
          }, {
            default: s(() => [
              m(u(e.description), 1)
            ]),
            _: 1
          }, 8, ["bottom-spacing", "class"])) : i("", !0),
          e.title ? (t(), r(n, {
            key: 1,
            title: e.title,
            size: "xs"
          }, null, 8, ["title"])) : i("", !0)
        ], 64)) : (t(), o(l, { key: 1 }, [
          e.title ? (t(), r(n, {
            key: 0,
            title: e.title,
            size: "s"
          }, null, 8, ["title"])) : i("", !0),
          e.description ? (t(), r(d, {
            key: 1,
            size: "xs",
            "top-spacing": e.Spacing.s,
            class: a({
              "hobi-image-card__description--lineclamp tw-overflow-hidden tw-overflow-ellipsis tw-break-words": e.descriptionClampText
            })
          }, {
            default: s(() => [
              m(u(e.description), 1)
            ]),
            _: 1
          }, 8, ["top-spacing", "class"])) : i("", !0)
        ], 64))
      ], 2)) : i("", !0)
    ], 64))
  ], 2);
}
const H = /* @__PURE__ */ S(h, [["render", T], ["__scopeId", "data-v-f924deed"]]);
export {
  H as default
};
